// ----------------------------------------------------------------------
// <copyright file="Izenda.Loading.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var { invoke } = require('lodash/fp');

  var Loading = observer(
    React.createClass({
      onCancel: function() {
        invoke('onCancel', this.props);
      },

      render: function() {
        var props = this.props;

        if (!props.show) {
          return null;
        }

        var loadingStrip = (
          <div
            className='progress-bar progress-bar-striped active u_fullWidth'
            aria-valuenow='100'
            aria-valuemin='0'
            aria-valuemax='100'
          />
        );

        loadingStrip = invoke('allowToCancelProgress', props)
          ? renderWithCancelBtn.call(this, loadingStrip)
          : loadingStrip;

        var loadingContent = props.withoutBorder ? (
          loadingStrip
        ) : (
          <div className='Reporting-Loading-Overlay'>
            <div className='Reporting-Loading-Canvas'>{loadingStrip}</div>
          </div>
        );

        if (props.classNameContainer) {
          return <div className={props.classNameContainer}>{loadingContent}</div>;
        } else {
          return loadingContent;
        }

        function renderWithCancelBtn(loadingStrip) {
          return (
            <div className='Loading-With-Btns u-posRelative'>
              <div className='progress-section'>{loadingStrip}</div>
              <div className='btn-section u-posAbsolute u-posTopRight'>
                <a label='Cancel' onClick={this.onCancel}>
                  Cancel
                </a>
              </div>
            </div>
          );
        }
      }
    })
  );

  Loading.propTypes = {
    show: React.PropTypes.bool,
    withoutBorder: React.PropTypes.bool
  };
  module.exports = Loading;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Loading.jsx